import { Dispatch, SetStateAction } from 'react';
import createNamedContext from 'utils/createNamedContext';

export interface BuyerFAQMeta {
  storeId: string;
  buyerId: string;
  activeKey?: 'faq' | 'trade';
}

export interface BuyerFAQContextValue {
  autoTranslate: boolean;
  setAutoTranslate: Dispatch<SetStateAction<boolean>>;
  show: (meta?: BuyerFAQMeta) => void;
}

export const BuyerFAQContext = createNamedContext<BuyerFAQContextValue | null>(
  'BuyerFAQContext',
  null,
);
